



































import Vue from 'vue';
import moment from 'moment';
import {
  mapActions,
  mapGetters,
} from 'vuex';

import api from '../../../api';
import { IShowGenreObject } from '../../../../../shared/types';

interface IData {
  genres: IShowGenreObject[],
  liked: boolean;
}

interface IMethods {
  like: (payload: Record<string, string | number>) => void;
  unlike: (payload: Record<string, string | number>) => void;
  interact: () => void;
}

interface IComputed {
  getSaved: Record<number, boolean>;
  isSaved: boolean;
  releaseDateFormated: string;
}

interface IProps {
  id: number;
  name: string;
  image: string;
  releaseDate: number;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'ShowHeader',

  props: {
    id: {
      type: Number,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    image: {
      type: String,
      required: true,
    },

    releaseDate: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    genres: [] as IShowGenreObject[],
    liked: false,
  }),

  async created() {
    this.genres = await api.show.getShowGenres(this.id);
    this.liked = this.isSaved;
  },

  computed: {
    ...mapGetters('shows', [
      'getSaved',
    ]),

    isSaved() {
      return this.id in this.getSaved && this.getSaved[this.id];
    },

    releaseDateFormated() {
      return moment(this.releaseDate).format('MMMM Do YYYY');
    },
  },

  methods: {
    ...mapActions('shows', [
      'like',
      'unlike',
    ]),

    interact() {
      this.liked = !this.liked;
      if (!this.liked) {
        this.unlike({
          id: this.id,
        });
      } else {
        this.like({
          id: this.id,
        });
      }
    },
  },
});
